export default "__VITE_ASSET__PzOVMi8M__"